import React, { useEffect } from "react";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Helmet } from "react-helmet";
import Banner from "../assets/images/WhyIKFreedomMatters/banner.png";

const WhyIKFreedomMatters = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <React.Fragment>
            <Helmet>
                <title>Why Imran Khan’s Freedom Matters | First Pakistan Global</title>
            </Helmet>

            <Header />

            {/* Hero */}
            <section id="why-ik-freedom-matters">
                <div className="text-center">
                    <div
                        className="bg-common py-5"
                        style={{ backgroundImage: `url(${Banner})`, backgroundPosition: 'center -70px', backgroundSize: 'cover' }}
                    >
                        {/* testing <img src={'/images/WhyIKFreedomMatters/banner.png'} alt="Why Imran Khan's Freedom Matters" className="img-fluid d-md-none" /> */}
                        <div className="text-white fs-ss-68 py-4 py-md-5 my-md-5 overlay-content">
                            <div className="fw-700 text-uppercase">
                                <div className="fw-700">Why <span style={{ color: "#51c482" }}>Imran Khan’s <br /> Freedom</span> Matters</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="py-4 py-md-5" />

                {/* Lead / Dek */}
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-11 col-md-10">
                            <h3 className="text-dark fs-ss-35 fw-600 pb-2 pb-md-4 text-md-center">
                                <span className="text-ss-primary">
                                    Pakistan’s military crackdown
                                </span>{" "}
                                endangers U.S. interests
                            </h3>

                            <div className="text-poppins fs-ss-16 lh-lg fw-400">
                                Two years ago, Pakistan’s most popular leader was dragged from
                                his home and thrown into a prison cell the size of a closet.
                                Since then, Imran Khan — the country’s former prime minister —
                                has endured solitary confinement, denial of medical care, and
                                more than 200 politically motivated charges. His crime? Daring
                                to challenge Pakistan’s military establishment.
                                <div className="py-1" />
                                The United Nations has already declared Khan’s detention
                                arbitrary and politically motivated. Yet Pakistan’s generals,
                                led by Army Chief Gen. Asim Munir, continue to tighten their
                                grip on the country of 250 million people. The result is a
                                democracy in name only: courts sidelined, journalists silenced,
                                opposition leaders tried in military courts, and elections
                                openly manipulated.
                            </div>
                        </div>
                    </div>
                </div>

                <div className="py-4 py-md-5" />

                {/* Section: Descent */}
                <div className="container-fluid" id="descent">
                    <div className="row justify-content-center">
                        <div className="col-11 col-md-10">
                            <h3 className="text-dark fs-ss-35 fw-600 pb-2 pb-md-3">
                                A Descent into Authoritarianism
                            </h3>
                            <div className="text-poppins fs-ss-16 lh-lg fw-400">
                                Pakistan is living under what many call an undeclared martial
                                law. Peaceful protesters face live fire. Social media platforms
                                are regularly shut down. Opposition members languish in jail
                                while civilians are prosecuted by military tribunals. February’s
                                election was so rigged that independent observers declared it
                                neither free nor fair.
                                <div className="py-1" />
                                At the center of it all is Gen. Munir, who is maneuvering to
                                extend his tenure beyond its constitutional limit. History shows
                                such extensions corrode both democracy and the military’s
                                integrity, concentrating power in one man while sidelining
                                senior leadership. Khan’s relentless persecution is about more
                                than settling scores. It is about removing any obstacle to
                                Munir’s rule.
                            </div>
                        </div>
                    </div>
                </div>

                <div className="py-4 py-md-5" />

                {/* Section: Why America Should Care */}
                <div className="container-fluid" id="why-america-should-care">
                    <div className="row justify-content-center">
                        <div className="col-11 col-md-10">
                            <h3 className="text-dark fs-ss-35 fw-600 pb-2 pb-md-3">
                                Why America Should Care
                            </h3>
                            <div className="text-poppins fs-ss-16 lh-lg fw-400">
                                Some in Washington dismiss Khan’s fate as an internal affair. It
                                is not. Pakistan is the 5th most populous nuclear-armed nation
                                at the crossroads of South Asia, bordering China, India, Iran,
                                and Afghanistan. Its stability — or instability — directly
                                affects U.S. interests.
                                <div className="py-1" />
                                When in office, Khan advanced those interests. He facilitated
                                the Afghan peace deal that allowed America to withdraw from its
                                longest war. He promoted regional stability and earned
                                international recognition for his leadership during the COVID-19
                                crisis. Even President Donald Trump publicly praised him as a
                                trusted partner.
                                <div className="py-1" />
                                A Pakistan run by generals, however, is brittle and volatile. It
                                risks fueling extremism, destabilizing the region, and
                                undermining U.S. credibility. Already, America’s silence is seen
                                by many in Pakistan’s diaspora as tacit support for
                                dictatorship.
                            </div>
                        </div>
                    </div>
                </div>

                <div className="py-4 py-md-5" />

                {/* Section: What Washington Can Do */}
                <div className="container-fluid" id="what-washington-can-do">
                    <div className="row justify-content-center">
                        <div className="col-11 col-md-10">
                            <h3 className="text-dark fs-ss-35 fw-600 pb-2 pb-md-3">
                                What Washington Can Do
                            </h3>
                            <div className="text-poppins fs-ss-16 lh-lg fw-400">
                                The U.S. cannot dictate who governs Pakistan. But it can decide
                                whether to bankroll authoritarianism. Billions of dollars in
                                military aid, intelligence cooperation, and diplomatic cover give
                                Washington leverage. That leverage should be used to press for
                                four basic steps:
                                <div className="py-2" />
                                <ol className="ps-5">
                                    <li className="mb-2">
                                        Release all political prisoners, including Imran Khan.
                                    </li>
                                    <li className="mb-2">
                                        Restore judicial independence and civilian supremacy.
                                    </li>
                                    <li className="mb-2">
                                        Ensure free, fair elections monitored by neutral
                                        international observers.
                                    </li>
                                    <li className="mb-2">
                                        Guarantee that Gen. Asim Munir exits when his tenure ends in
                                        November 2025.
                                    </li>
                                </ol>
                                <div className="py-1" />
                                Congress can make future assistance conditional on these
                                benchmarks. The administration should employ the Global
                                Magnitsky Act to sanction individuals responsible for human
                                rights abuses and transnational repression. And if Gen. Munir
                                tries to extend his term, Washington should treat it as a red
                                line.
                            </div>
                        </div>
                    </div>
                </div>

                <div className="py-4 py-md-5" />

                {/* Section: Test of Credibility */}
                <div className="container-fluid" id="test-of-credibility">
                    <div className="row justify-content-center">
                        <div className="col-11 col-md-10">
                            <h3 className="text-dark fs-ss-35 fw-600 pb-2 pb-md-3">
                                A Test of Credibility
                            </h3>
                            <div className="text-poppins fs-ss-16 lh-lg fw-400">
                                Supporting Khan’s release is not about endorsing one politician.
                                It is about siding with Pakistan’s people, who — like Americans —
                                deserve to choose their leaders at the ballot box. It is also
                                about credibility. Washington cannot claim to champion democracy
                                abroad while ignoring the dismantling of democratic institutions
                                in a country of 250 million people with nuclear weapons.
                                <div className="py-1" />
                                <span className="fw-600">
                                    Imran Khan’s freedom matters — for Pakistan’s democracy and
                                    for America’s.
                                </span>
                            </div>

                            {/* Prepared by / Attribution */}
                            <div className="py-3" />
                            <div className="border rounded-4 p-3 p-md-4 bg-light">
                                <div className="text-poppins fs-ss-16 lh-lg fw-400">
                                    <span className="fw-600">Prepared by First Pakistan Global (FPG)</span>
                                    <div className="py-1" />
                                    A U.S.-based nonprofit dedicated to advancing democracy, human
                                    rights, and the rule of law in Pakistan.
                                    <div className="py-1" />
                                    <a
                                        href="https://x.com/FirstPakGlobal"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="text-decoration-none text-ss-primary fw-600"
                                    >
                                        https://x.com/FirstPakGlobal
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="py-4 py-md-5" />
            </section>

            <Footer />
            <style>{`
  /* Parent needs positioning so the overlay can anchor */
  .bg-common.py-5 { 
    position: relative; 
  }

  /* Semi-transparent overlay on top of the background image */
  .bg-common.py-5::after {
    content: "";
    position: absolute;
    inset: 0;                /* top:0; right:0; bottom:0; left:0 */
    background: rgba(18, 50, 8, 0.54);
    z-index: 1;              /* sits above the background, below the content */
    pointer-events: none;    /* overlay won’t block clicks */
  }

  /* Ensure your text/content sits above the overlay */
  .bg-common .overlay-content {
    position: relative;
    z-index: 2;
        line-height: 80px;
  }
    
`}</style>
        </React.Fragment>

    );

};

export default WhyIKFreedomMatters;
